export default {"src":"/_next/static/media/clock-countdown.3fdb01b8.svg","height":36,"width":36};